<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as PHONE_TYPOLOGY_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'PhoneTypologyCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: PHONE_TYPOLOGY_TYPES.GENERIC.organization.phonetypology.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...PHONE_TYPOLOGY_TYPES.GENERIC.organization.phonetypology.LIST.ACTIONS
    })
  }
}
</script>
